import { memo, useMemo, useRef } from "react";
import { Divider } from "@mui/material";
import { useGetColumns } from "../hooks/useGetColumns";
import { LiquidacionFinalGrillaPorProfesional } from "./LiquidacionFinalGrillaPorProfesional";

const LiquidacionFinalGrillaWrapperBase = ({
    idProfesionalLiquidacion,
    profesionalData,
    liquidaciones,
    mesLiquidado,
    allowedWrite,
    seleccionados,
    toggleSeleccion,
    seleccionarTodos,
    handleViewDetalle,
    showDivider,
    mostrarOrdenCompra
}) => {
    // Estabilizamos los handlers con refs para que useGetColumns no regenere columns
    // cuando el padre pasa nuevas instancias de funciones en cada render
    const handleViewDetalleRef = useRef(handleViewDetalle);
    handleViewDetalleRef.current = handleViewDetalle;

    const stableHandleView = useRef((...args) => handleViewDetalleRef.current(...args)).current;

    const columns = useGetColumns({
        allowedWrite,
        handleView: stableHandleView,
        idProfesionalLiquidacion,
        seleccionados,
        toggleSeleccion,
        seleccionarTodos,
        liquidaciones,
        mostrarOrdenCompra
    });

    return (
        <>
            <LiquidacionFinalGrillaPorProfesional
                idProfesionalLiquidacion={idProfesionalLiquidacion}
                columns={columns}
                profesionalData={profesionalData}
                liquidaciones={liquidaciones}
                mesLiquidado={mesLiquidado}
                allowedWrite={allowedWrite}
                seleccionados={seleccionados}
                seleccionarTodos={seleccionarTodos}
            />
            {showDivider && <Divider sx={{ my: 2.5 }} />}
        </>
    );
};

export const LiquidacionFinalGrillaWrapper = memo(
    LiquidacionFinalGrillaWrapperBase,
    (prev, next) => {
        // Re-renderizar SOLO si cambió algo de este profesional específico
        // (no cuando cambia la selección de otro profesional)
        return (
            prev.idProfesionalLiquidacion === next.idProfesionalLiquidacion &&
            prev.liquidaciones === next.liquidaciones &&
            prev.profesionalData === next.profesionalData &&
            prev.seleccionados === next.seleccionados &&
            prev.mesLiquidado === next.mesLiquidado &&
            prev.allowedWrite === next.allowedWrite &&
            prev.showDivider === next.showDivider &&
            prev.mostrarOrdenCompra === next.mostrarOrdenCompra
            // Los handlers no se comparan — son estables por ref internamente
        );
    }
);
